import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { getLogs } from 'redux/stockSlice';
import { UseSelector, useSelector } from 'react-redux/es/hooks/useSelector';
import styles from "./Logs.module.scss"
import Table from 'components/shared/table/Table';
import { dateConverter, downloadFile, processArray } from 'utils/utils';
import Button from 'components/shared/button/Button';
import { Loader } from 'components/shared/loader/Loader';

const Logs = () => {
    const { logs, load } = useSelector((state) => state.stock)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getLogs())
    }, [])


    const columns = [
        {
            name: 'Id',
            selector: row => row?.id
        },
        {
            name: 'Date',
            selector: row => dateConverter(row?.createdAtDate)
        },
        {
            name: 'Stock Name',
            width: "400px",
            selector: row => row?.reportName || "-"
        },
        {
            name: 'Status',
            selector: row => <div className={
                row?.status == 1 ? styles.success : styles.error
            } >
                {row?.status == 1 ? "Success" : "Failed"}
            </div>
        },
        {
            name: 'Action',
            selector: row => <Button
                label="Download"
                onClick={() => {
                    const temp = []
                    console.log('row?.outputLink', downloadFile)
                    row?.outputLink && downloadFile(row?.outputLink, row?.reportName)
                    // row?.lplInputLink && temp.push(row?.lplInputLink)
                    // row?.stockInputLink && temp.push(row?.stockInputLink)
                    // processArray(temp);
                }}
                disabled={row?.status !== 1}
            />
        },
        {
            name: 'Input File Download',
            selector: row => <Button
                label="Download"
                onClick={() => {
                    const temp = []
                    row?.lplInputLink && temp.push(row?.lplInputLink)
                    row?.stockInputLink && temp.push(row?.stockInputLink)
                    processArray(temp);

                }}
            />
        },
    ];
    let data;
    if (logs) {
        data = [
            ...logs
        ]
    }
    // const data = [
    //     ...logs
    // ]

    const sortedData = data?.sort((a, b) => b.id - a.id);

    return (
        load ? <Loader /> : <Table
            columns={columns}
            data={sortedData}
        />
    )
}

export default Logs